import React, { lazy, Suspense, useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import Aos from 'aos'

import LoadingScreen from './components/page/LoadingScreen/LoadingScreen';

import * as actions from './store/actions/actions'

import 'aos/dist/aos.css'

const Error404 = lazy(() => import('./components/page/Error404/Error404'))
const Home = lazy(() => import('./components/page/Home/Home'))

function App({ hasError, isDarkMode, isDataLoading, getData, switchDarkMode }) {
  useEffect(() => {
    Aos.init({
      duration: 600
    })
    if (window.localStorage.getItem("isDarkMode") === "true") {
      switchDarkMode(true)
    }
    getData()
  }, [])

  return (
    <div className={`${isDarkMode && "dark"}`}>
      {(isDataLoading || hasError) ? <LoadingScreen /> :
        <Suspense fallback={<LoadingScreen />}>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route component={Error404} />
          </Switch>
        </Suspense>}
    </div>
  );
}

const mapSTP = state => ({
  isDarkMode: state.ui.isDarkMode,
  isDataLoading: state.data.isLoading,
  hasError: state.data.error,
})

const mapDTP = dispatch => ({
  getData: () => dispatch(actions.getData()),
  switchDarkMode: (value) => {
    dispatch(actions.setIsDarkMode(value))
  }
})

export default connect(mapSTP, mapDTP)(App);
